export default __webpack_public_path__ + "static/shop_apparel-d0a49bc8eaacafac6ade3f4ca14d982d.png";